import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    endsAt: String,
    showSeconds: { type: Boolean, default: false },
    padded: { type: Boolean, default: false },
  };
  static targets = ['days', 'hours', 'minutes', 'seconds'];

  #timer;

  connect() {
    this.#start();
  }

  disconnect() {
    clearInterval(this.#timer);
  }

  endsAtValueChanged() {
    this.#start();
  }

  // private

  #start() {
    clearInterval(this.#timer);
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  #format(n) {
    return this.paddedValue ? String(n).padStart(2, '0') : String(n);
  }

  #tick() {
    const raw = new Date(this.endsAtValue) - Date.now();
    const diff = Math.max(0, raw);

    if (raw <= 0) {
      clearInterval(this.#timer);
    }

    const d = Math.floor(diff / 86_400_000);
    const h = Math.floor((diff % 86_400_000) / 3_600_000);
    const m = Math.floor((diff % 3_600_000) / 60_000);
    const s = Math.floor((diff % 60_000) / 1_000);

    this.element.dataset.remainingDays = d;

    this.daysTarget.textContent = this.#format(d);
    this.hoursTarget.textContent = this.#format(h);
    this.minutesTarget.textContent = this.#format(m);

    if (this.showSecondsValue && this.hasSecondsTarget) {
      this.secondsTarget.textContent = this.#format(s);
    }
  }
}
